import { Component, Input } from '@angular/core';
import { GenericContentType } from '../../../types/common.types';

@Component({
  selector: 'idp-generic-content',
  templateUrl: './generic-content.component.html',
  styleUrls: ['./generic-content.component.scss']
})
export class GenericContentComponent {
  @Input() title = '';
  @Input() message = '';
  @Input() type: GenericContentType = '';
}
